module.exports = __webpack_public_path__ + "static/media/tv.4668cb8b.png";